import React, { useRef, useState, useEffect } from 'react';
import SignaturePad from 'react-signature-canvas';
import SignatureModal from './SignatureModal';

const SignatureTableField = ({ value, onChange, isPrint }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sigPad = useRef();

  useEffect(() => {
    if (sigPad.current) {
      if (value) {
        sigPad.current.fromDataURL(value);
      }
    }
  }, [sigPad]);

  const handleSave = (data) => {
    if (sigPad.current) {
      sigPad.current.clear();
      onChange(data);
      setIsModalOpen(false);
      sigPad.current.fromDataURL(data);
    }
  };

  return (
    <>
      <div className={`sigCanvas-wrapper`} onClick={isPrint ? () => {} : () => setIsModalOpen(true)} style={{ height: '40px' }}>
        <SignaturePad ref={sigPad} penColor="black" clearOnResize={false} canvasProps={{ className: `sigCanvas readonly` }} />
      </div>

      {isModalOpen && <SignatureModal value={value} onClose={() => setIsModalOpen(false)} handleSave={handleSave} />}
    </>
  );
};

export default SignatureTableField;
